<template lang="pug">
  b-modal#modal-scrollable.context(
    v-if="dialog.submit.sort === 'reject'",
    v-model="show",
    size="md",
    header-class="lmm-common-popup-header",
    :header-text-variant="dialog.headerTextVariant",
    :body-bg-variant="dialog.bodyBgVariant",
    :body-text-variant="dialog.bodyTextVariant",
    :footer-bg-variant="dialog.footerBgVariant",
    :footer-text-variant="dialog.footerTextVariant"
    no-close-on-backdrop)
    template(slot="modal-header")
      img.logo(src="../../assets/main_logo.svg" style="height: 20px")
    b-card
      b-container(fluid)
        div.context
          b-form
            b-form-group(
              content-cols-sm
              :label="$t('request-agent')"
              label-for="device-name"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#device-name(:placeholder="`${this.newSubmitValue.device_alias}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('ID')"
              label-for="id"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#id(:placeholder="`${this.newSubmitValue.requester_id}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('name')"
              label-for="name"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#name(:placeholder="`${this.newSubmitValue.requester_name}`" disabled)
            b-form-group.request-date(
              content-cols-sm
              :label="$t('request-date')"
              label-for="app-period"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-datepicker#app-period(
                :placeholder="`${this.newSubmitValue.start_time}`",
                v-model="newSubmitValue.start_time",
                :date-disabled-fn="dateDisabled")
              b-form-timepicker(:placeholder="`${newSubmitValue.start_time_time}`" v-model="newSubmitValue.start_time_time")
              b-form-datepicker#app-period-after.mt-2(
                :placeholder="`${this.newSubmitValue.end_time}`",
                v-model="newSubmitValue.end_time",
                :date-disabled-fn="dateDisabledEnd")
              b-form-timepicker(:placeholder="`${newSubmitValue.end_time_time}`" v-model="newSubmitValue.end_time_time")
            b-form-group(
              content-cols-sm
              :label="$t('approver')"
              label-for="approval"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#approval(:placeholder="`${this.newSubmitValue.approver_name}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('request-reason')"
              label-for="approval-reason"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-textarea#approval-reason(:placeholder="`${this.newSubmitValue.approval_reason}`" v-model="newSubmitValue.approval_reason")
            b-form-group(
              content-cols-sm
              :label="$t('approval-reason')"
              label-for="companion-reason"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-textarea#companion-reason(:placeholder="`${this.newSubmitValue.react_reason}`" disabled)
    template(slot="modal-footer")
      b-button(
        variant="secondary"
        size="sm"
        @click="close") {{$t('cancel')}}
      b-button(
        size="sm"
        :variant="dialog.submit.color"
        @click="submit", v-t="dialog.submit.text")

  b-modal#modal-scrollable.context(
    v-else-if="dialog.submit.sort === 'ing'",
    v-model="show",
    size="md",
    header-class="lmm-common-popup-header",
    :header-text-variant="dialog.headerTextVariant",
    :body-bg-variant="dialog.bodyBgVariant",
    :body-text-variant="dialog.bodyTextVariant",
    :footer-bg-variant="dialog.footerBgVariant",
    :footer-text-variant="dialog.footerTextVariant"
    no-close-on-backdrop
    scrollable)
    template(slot="modal-header")
        img.logo(:src="`${AppState.Path.image}/main_logo.svg`")
    b-card
      b-container(fluid)
        div.context
          b-form
            b-form-group(
              content-cols-sm
              :label="$t('request-agent')"
              label-for="device-name"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#device-name(:placeholder="`${this.newSubmitValue.device_alias}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('ID')"
              label-for="id"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#id(:placeholder="`${this.newSubmitValue.requester_id}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('name')"
              label-for="name"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#name(:placeholder="`${this.newSubmitValue.requester_name}`" disabled)
            b-form-group.request-date(
              content-cols-sm
              :label="$t('request-date')"
              label-for="app-period"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-datepicker#app-period(
                :placeholder="`${this.newSubmitValue.start_time}`",
                v-model="newSubmitValue.start_time",
                :date-disabled-fn="dateDisabled")
              b-form-timepicker(:placeholder="`${this.newSubmitValue.start_time_time}`" v-model="newSubmitValue.start_time_time")
              b-form-datepicker#app-period-after.mt-2(
                :placeholder="`${this.newSubmitValue.end_time}`",
                v-model="newSubmitValue.end_time",
                :date-disabled-fn="dateDisabledEnd")
              b-form-timepicker(:placeholder="`${this.newSubmitValue.end_time_time}`" v-model="newSubmitValue.end_time_time")
            b-form-group(
              content-cols-sm
              :label="$t('approver')"
              label-for="approval"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#approval(:placeholder="`${this.newSubmitValue.approver_name}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('request-reason')"
              label-for="approval-reason"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-textarea#approval-reason(:placeholder="`${this.newSubmitValue.approval_reason}`" v-model="newSubmitValue.approval_reason")
    template(slot="modal-footer")
      b-button(
        variant="secondary"
        size="sm"
        @click="close") {{$t('cancel')}}
      b-button(
        size="sm"
        :variant="dialog.submit.color"
        @click="submit", v-t="dialog.submit.text")

  b-modal#modal-scrollable.context(
    v-else-if="dialog.submit.sort === 'admin'",
    v-model="show",
    size="md",
    header-class="lmm-common-popup-header",
    :header-text-variant="dialog.headerTextVariant",
    :body-bg-variant="dialog.bodyBgVariant",
    :body-text-variant="dialog.bodyTextVariant",
    :footer-bg-variant="dialog.footerBgVariant",
    :footer-text-variant="dialog.footerTextVariant"
    no-close-on-backdrop
    scrollable)
    template(slot="modal-header")
        img.logo(:src="`${AppState.Path.image}/main_logo.svg`")
    b-card
      b-container(fluid)
        div.context
          b-form
            b-form-group(
              content-cols-sm
              :label="$t('request-agent')"
              label-for="device-name"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#device-name(:placeholder="`${this.adminSubmitValue.device_alias}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('ID')"
              label-for="id"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#id(:placeholder="`${this.adminSubmitValue.requester_id}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('name')"
              label-for="name"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#name(:placeholder="`${this.adminSubmitValue.requester_name}`" disabled)
            b-form-group.request-date(
              content-cols-sm
              :label="$t('request-date')"
              label-for="app-period"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-datepicker#app-period(:placeholder="`${this.adminSubmitValue.start_time}`" disabled)
              b-form-timepicker(:placeholder="`${this.adminSubmitValue.start_time_time}`" disabled)
              b-form-datepicker#app-period-after.mt-2(:placeholder="`${this.adminSubmitValue.end_time}`" disabled)
              b-form-timepicker(:placeholder="`${this.adminSubmitValue.end_time_time}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('approver')"
              label-for="approval"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#approval(:placeholder="`${this.adminSubmitValue.approver_name}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('request-reason')"
              label-for="approval-reason"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-textarea#approval-reason(:placeholder="`${this.adminSubmitValue.reason}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('approval-reason')"
              label-for="companion-reason"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-textarea#companion-reason(
                v-model="adminSubmitValue.react_reason"
              )
    template(slot="modal-footer")
      div.btn-wrap
        b-button(
          size="sm"
          @click="close") {{$t('close')}}
        b-button.ml-2(
          size="sm"
          :variant="dialog.reject.color"
          @click="reject", v-t="dialog.reject.text")
        b-button.ml-2(
          size="sm"
          :variant="dialog.submit.color"
          @click="submit", v-t="dialog.submit.text")

  b-modal#modal-scrollable.context(
    v-else-if="dialog.submit.sort === 'admin_history'",
    v-model="show",
    size="md",
    header-class="lmm-common-popup-header"
    :header-text-variant="dialog.headerTextVariant",
    :body-bg-variant="dialog.bodyBgVariant",
    :body-text-variant="dialog.bodyTextVariant",
    :footer-bg-variant="dialog.footerBgVariant",
    :footer-text-variant="dialog.footerTextVariant"
    no-close-on-backdrop
    scrollable)
    template(slot="modal-header")
        img.logo(:src="`${AppState.Path.image}/main_logo.svg`")
    b-card
      b-container(fluid)
        div.context
          b-form
            b-form-group(
              content-cols-sm
              :label="$t('request-agent')"
              label-for="device-name"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#device-name(:placeholder="`${this.adminHistoryValue.device_alias}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('ID')"
              label-for="id"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#id(:placeholder="`${this.adminHistoryValue.requester_id}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('name')"
              label-for="name"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#name(:placeholder="`${this.adminHistoryValue.requester_name}`" disabled)
            b-form-group.request-date(
              content-cols-sm
              :label="$t('request-date')"
              label-for="app-period"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-datepicker#app-period(:placeholder="`${this.adminHistoryValue.start_time}`" disabled)
              b-form-datepicker#app-period-after(:placeholder="`${this.adminHistoryValue.end_time}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('approver')"
              label-for="approval"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#approval(:placeholder="`${this.adminHistoryValue.approver_name}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('request-reason')"
              label-for="approval-reason"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-textarea#approval-reason(:placeholder="`${this.adminHistoryValue.reason}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('approval-reason')"
              label-for="companion-reason"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-textarea#companion-reason(:placeholder="`${this.adminHistoryValue.react_reason}`" v-model="adminHistoryValue.react_reason")
    template(slot="modal-footer")
      // approve_state : 1 (반려), 2 (승인), 4 (장치삭제)
      b-button(
        size="sm",
        @click="close") {{$t('close')}}
      b-button(
        v-if="dialog.item.approve_state === 1",
        size="sm"
        variant="primary"
        @click="submit") {{$t('approval')}}
      b-button(
        v-else-if="dialog.item.approve_state === 2",
        size="sm"
        variant="danger"
        @click="reject") {{$t('reject-submit')}}
      b-button(
        v-else,
        size="sm"
        variant="primary"
        @click="reject") {{$t('deleted-device-edit')}}

  // @@@
  b-modal#modal-scrollable.context(
    v-else-if="dialog.submit.sort === 'new'",
    v-model="show",
    size="md",
    header-class="lmm-common-popup-header",
    :header-text-variant="dialog.headerTextVariant",
    :body-bg-variant="dialog.bodyBgVariant",
    :body-text-variant="dialog.bodyTextVariant",
    :footer-bg-variant="dialog.footerBgVariant",
    :footer-text-variant="dialog.footerTextVariant"
    no-close-on-backdrop
    scrollable)
    template(slot="modal-header")
        img.logo(src="../../assets/main_logo.svg" style="height: 20px")
    b-card
      b-container(fluid)
        div.context
          b-form
            b-form-group(
              content-cols-sm
              :label="$t('request-agent')"
              label-for="device-name"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#device-name(:placeholder="`${this.newSubmitValue.device_alias}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('ID')"
              label-for="id"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#id(:placeholder="`${this.newSubmitValue.requester_id}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('name')"
              label-for="name"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#name(:placeholder="`${this.newSubmitValue.requester_name}`" disabled)
            b-form-group.request-date(
              content-cols-sm
              :label="$t('request-date')"
              label-for="app-period"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-datepicker#app-period(
                v-model="newSubmitValue.start_time",
                :date-disabled-fn="dateDisabled",
                :placeholder="$t('start_time_ch')")
              b-form-timepicker(
                v-model="newSubmitValue.start_time_time",
                :placeholder="$t('start_time_time')")
              b-form-datepicker#app-period-after.mt-2(
                v-model="newSubmitValue.end_time",
                :date-disabled-fn="dateDisabledEnd",
                :placeholder="$t('end_time_ch')")
              b-form-timepicker(
                v-model="newSubmitValue.end_time_time",
                :placeholder="$t('end_time_time')")
            b-form-group(
              content-cols-sm
              :label="$t('approver')"
              label-for="approval"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#approval(:placeholder="`${this.newSubmitValue.approver_name}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('request-reason')"
              label-for="approval-reason"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-textarea#approval-reason(v-model="newSubmitValue.approval_reason")
    template(slot="modal-footer")
      b-button(
        variant="secondary"
        size="sm"
        @click="close") {{$t('cancel')}}
      b-button(
        size="sm"
        variant="primary"
        @click="submit", v-t="dialog.submit.text")

  b-modal#modal-scrollable.context(
    v-else-if="dialog.submit.sort === 'renew'",
    v-model="show",
    size="md",
    header-class="lmm-common-popup-header",
    :header-text-variant="dialog.headerTextVariant",
    :body-bg-variant="dialog.bodyBgVariant",
    :body-text-variant="dialog.bodyTextVariant",
    :footer-bg-variant="dialog.footerBgVariant",
    :footer-text-variant="dialog.footerTextVariant"
    no-close-on-backdrop
    scrollable)
    template(slot="modal-header")
        img.logo(:src="`${AppState.Path.image}/main_logo.svg`")
    b-card
      b-container(fluid)
        div.context
          b-form
            b-form-group(
              content-cols-sm
              :label="$t('request-agent')"
              label-for="device-name"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#device-name(:placeholder="`${this.newSubmitValue.device_alias}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('ID')"
              label-for="id"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#id(:placeholder="`${this.newSubmitValue.requester_id}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('name')"
              label-for="name"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#name(:placeholder="`${this.newSubmitValue.requester_name}`" disabled)
            b-form-group.request-date(
              content-cols-sm
              :label="$t('request-date')"
              label-for="app-period"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-datepicker#app-period(
                v-model="newSubmitValue.start_time",
                :date-disabled-fn="dateDisabled")
              b-form-timepicker(v-model="newSubmitValue.start_time_time")
              b-form-datepicker#app-period-after.mt-2(
                v-model="newSubmitValue.end_time",
                :date-disabled-fn="dateDisabledEnd")
              b-form-timepicker(v-model="newSubmitValue.end_time_time")
            b-form-group(
              content-cols-sm
              :label="$t('approver')"
              label-for="approval"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-input#approval(:placeholder="`${this.newSubmitValue.approver_name}`" disabled)
            b-form-group(
              content-cols-sm
              :label="$t('request-reason')"
              label-for="approval-reason"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-textarea#approval-reason(:placeholder="`${this.newSubmitValue.approval_reason}`" v-model="newSubmitValue.approval_reason")
            b-form-group(
              content-cols-sm
              :label="$t('approval-reason')"
              label-for="companion-reason"
              label-cols-sm="3"
              label-align-sm="left"
            )
              b-form-textarea#companion-reason(
                :placeholder="`${this.newSubmitValue.react_reason}`"
                disabled
              )
    template(slot="modal-footer")
      b-button(
        variant="secondary"
        size="sm"
        @click="close") {{$t('cancel')}}
      b-button(
        size="sm"
        :variant="dialog.submit.color"
        @click="submit", v-t="dialog.submit.text")
</template>

<script>
import _ from 'lodash'
import {user} from '@/api/access'
import {ApprovalsAPI} from '../../api'
import moment from 'moment'

const defaultValues = {
  size: 'lg',
  title: '',
  context: '',
  headerBgVariant: 'light',
  headerTextVariant: 'dark',
  bodyBgVariant: 'light',
  bodyTextVariant: 'dark',
  footerBgVariant: 'light',
  footerTextVariant: 'dark',
  align: 'left',
  submit: {
    size: 'sm',
    text: 'submit',
    color: 'primary',
    sort: 'first'
  }
}
export default {
  name: 'approval-request-dialog',
  methods: {
    focusIn () {
      this.$refs.close.focus()
    },
    close () {
      this.show = false
    },
    dateDisabled (ymd, date) {
      const today = new Date().toJSON().slice(0,10).replace(/-/g,'-')

      return ymd < today
    },
    dateDisabledEnd (ymd, date) {
      const startTime = this.newSubmitValue.start_time

      return ymd < startTime
    },
    submit () {
      if (this.dialog.submit.sort === 'admin') {
        this.show = false
        let params = {
          pk:this.adminSubmitValue.approvePK,
          is_accept:1,
          react_reason:this.adminSubmitValue.react_reason
        }
        this.cb('submit', params)
        this.adminSubmitValue.react_reason = ''
      } else if (this.dialog.submit.sort === 'admin_history') {
        this.show = false
        let params = {
          pk: this.adminHistoryValue.approvePK,
          is_accept:1,
          react_reason:this.adminHistoryValue.react_reason
        }
        this.cb('submit', params)
      } else {
        let params = {
          // new : device_pk => device.js에서 추가
          device_pk: this.newSubmitValue.device_pk,
          approver_pk: this.newSubmitValue.approver_pk,
          approver_name: this.newSubmitValue.approver_name,
          start_time: this.newSubmitValue.start_time + ' ' + this.newSubmitValue.start_time_time,
          end_time: this.newSubmitValue.end_time + ' ' + this.newSubmitValue.end_time_time,
          approval_reason: this.newSubmitValue.approval_reason
        }
        if (params.start_time >= params.end_time || !this.newSubmitValue.start_time || !this.newSubmitValue.start_time_time || !this.newSubmitValue.end_time || !this.newSubmitValue.end_time_time) {
          this.AppState.$emit('show-message-dialog', { context: {path: 'date_validate_error'}})
        } else if (!params.approval_reason) {
          this.AppState.$emit('show-message-dialog', { context: {path: 'approvals_reason'}})
        } else {
          this.show = false
          this.cb('submit', params)
          this.newSubmitValue.approval_reason = ''
        }
      }
    },
    reject () {
      if (this.dialog.submit.sort === 'admin') {
        this.show = false
        let params = {
          pk:this.adminSubmitValue.approvePK,
          is_accept:0,
          react_reason:this.adminSubmitValue.react_reason
        }
        this.cb('reject', params)
        this.adminSubmitValue.react_reason = ''
      } else if (this.dialog.submit.sort === 'admin_history') {
        this.show = false
        let params = {
          pk:this.adminHistoryValue.approvePK,
          is_accept:0,
          react_reason:this.adminHistoryValue.react_reason
        }
        this.cb('reject', params)
      }
    },
    async getApproval () {
      //승인자정보GET
      const resp=await ApprovalsAPI.get('approver')
      
      this.newSubmitValue.approver_pk = resp.data.objects[0].pk
      this.newSubmitValue.approver_name = resp.data.objects[0].name
      
      return resp.data.objects
    }
  },
  created () {
    this.dialog = defaultValues
    this.AppState.$on('show-approval-request-dialog', (data, cb) => {
      this.dialog = _.assignIn({}, defaultValues, data)
      if (data.value) this.value = data.value
      if (typeof cb === 'function') this.cb = cb
      this.show = true
      if (data.submit.sort === 'admin') {
        this.adminSubmitValue.approveInfo = data.approveInfo
        this.adminSubmitValue.approvePK = data.approvePK
        for (let i=0; i<this.adminSubmitValue.approveInfo.length; i++) {
          if (this.adminSubmitValue.approveInfo[i].pk == this.adminSubmitValue.approvePK) {
            this.adminSubmitValue.device_alias = this.adminSubmitValue.approveInfo[i].device_alias
            this.adminSubmitValue.requester_id = this.adminSubmitValue.approveInfo[i].requester_id
            this.adminSubmitValue.requester_name = this.adminSubmitValue.approveInfo[i].requester_name
            this.adminSubmitValue.approver_name = this.adminSubmitValue.approveInfo[i].approver_name
            this.adminSubmitValue.start_time = moment(this.adminSubmitValue.approveInfo[i].start_time).format('YYYY-MM-DD')
            this.adminSubmitValue.start_time_time = moment(this.adminSubmitValue.approveInfo[i].start_time).format('HH:mm:ss')
            this.adminSubmitValue.end_time = moment(this.adminSubmitValue.approveInfo[i].end_time).format('YYYY-MM-DD')
            this.adminSubmitValue.end_time_time = moment(this.adminSubmitValue.approveInfo[i].end_time).format('HH:mm:ss')
            this.adminSubmitValue.reason = this.adminSubmitValue.approveInfo[i].reason
          }
        }
      } else if (data.submit.sort === 'new') {
        this.newSubmitValue.device_alias = data.alias

        const getUser = user()
        this.newSubmitValue.requester_id = getUser.mgrid
        this.newSubmitValue.requester_name = getUser.name

        this.newSubmitValue.start_time = ''
        this.newSubmitValue.start_time_time = ''
        this.newSubmitValue.end_time = ''
        this.newSubmitValue.end_time_time = ''
        this.getApproval()
      } else if (data.submit.sort === 'admin_history') {
        this.adminHistoryValue = data.item
        this.adminHistoryValue.start_time = moment(data.item.start_time).format('YYYY-MM-DD HH:mm:ss')
        this.adminHistoryValue.end_time = moment(data.item.end_time).format('YYYY-MM-DD HH:mm:ss')
        this.adminHistoryValue.approvePK = data.item.pk
        this.adminHistoryValue.react_reason = data.item.react_reason
      } else {
        this.newSubmitValue.requestInfo = data.requestInfo
        this.newSubmitValue.approvePK = data.approvePK
        for (let i=0; i<this.newSubmitValue.requestInfo.length; i++) {
          if (this.newSubmitValue.requestInfo[i].pk == this.newSubmitValue.approvePK) {
            this.newSubmitValue.device_alias = this.newSubmitValue.requestInfo[i].device_alias
            this.newSubmitValue.requester_id = this.newSubmitValue.requestInfo[i].requester_id
            this.newSubmitValue.requester_name = this.newSubmitValue.requestInfo[i].requester_name
            this.newSubmitValue.approver_name = this.newSubmitValue.requestInfo[i].approver_name
            this.newSubmitValue.start_time = moment(this.newSubmitValue.requestInfo[i].start_time).format('YYYY-MM-DD')
            this.newSubmitValue.start_time_time = moment(this.newSubmitValue.requestInfo[i].start_time).format('HH:mm:ss')
            this.newSubmitValue.end_time = moment(this.newSubmitValue.requestInfo[i].end_time).format('YYYY-MM-DD')
            this.newSubmitValue.end_time_time = moment(this.newSubmitValue.requestInfo[i].end_time).format('HH:mm:ss')
            this.newSubmitValue.react_reason = this.newSubmitValue.requestInfo[i].react_reason
            this.newSubmitValue.device_pk = this.newSubmitValue.requestInfo[i].device_fk
            this.newSubmitValue.approval_reason = this.newSubmitValue.requestInfo[i].reason
            this.newSubmitValue.approver_pk = this.newSubmitValue.requestInfo[i].approver_fk
          }
        }
      }
    })
  },
  data () {
    return {
      show: false,
      dialog: {},
      value: '',
      newSubmitValue: {
        requestInfo: [],
        approvePK: '',
        device_alias:'',
        requester_id:'',
        requester_name:'',
        start_time:'',
        end_time:'',
        start_time_time:'',
        end_time_time:'',
        approver_name:'',
        approval_reason:'',
        react_reason: '',
        approver_pk:'',
        device_pk: ''
      },
      adminSubmitValue: {
        approveInfo: [],
        approvePK:'',
        device_alias: '',
        requester_id: '',
        requester_name: '',
        start_time: '',
        end_time: '',
        start_time_time:'',
        end_time_time:'',
        approver_name: '',
        reason: '',
        react_reason: ''
      },
      adminHistoryValue: {
        start_time_time:'',
        end_time_time:'',
        approvePK:'',
        react_reason:''
      },
      cb () {}
    }
  }
}
</script>

<style lang="scss" scoped src="./dialogs.scss"></style>
<style lang="scss" scoped>
.btn-secondary {
  color: black !important;
  background-color: #FFFFFF;
  font-weight: 400;
}

.btn-primary {
  color: black;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #F7F7F7 !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #CBCBCB !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.card {
  border-radius: 0;
  .card-body {
    padding: 0;
  }
}

.container-fluid {
  padding: 1rem;
  margin: 0;
}

.form-group {
  display: flex;
  align-items: center;
}

.form-control {
  background-color: #FFFFFF !important;
  height: 1.9rem;
  color: #8F8F8F;
  font-size: 13px;
}

.request-date {
  align-items: start;
}

.b-form-timepicker, .b-form-datepicker {
  margin-top: 0.5rem;
}

.dropdown {
  display: flex;
  align-items: center;
}

::v-deep .modal-footer {
  border: none;
  padding: 0 1rem 1rem 1rem;
}

textarea {
  height: auto !important;
}
</style>
